"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const passage_details_1 = require("../../../model/passage-details");
const use_lazy_promise_1 = require("../../../hook/use-lazy-promise");
const feedback_1 = require("../../../network/feedback");
const button_1 = require("../../../component/input/button");
const log_1 = require("../../../model/log");
exports.FeedbackContainer = (0, react_1.memo)(({ currentPlayTime, passageDetails, onSubmit }) => {
    const textInputRef = (0, react_1.useRef)(null);
    const { execute: executeSendFeedback, status: sendFeedbackStatus } = (0, use_lazy_promise_1.useLazyPromise)(feedback_1.sendPassageFeedback);
    const currentWord = (0, react_1.useMemo)(() => {
        if (!currentPlayTime) {
            return undefined;
        }
        const words = passageDetails.blocks
            .flatMap((block) => {
            if (block.type === passage_details_1.PassageBlockType.Paragraph) {
                return block.sentences.flatMap((sentence) => sentence.words);
            }
            return [];
        })
            .reverse();
        const lastIndex = words.findIndex((w) => {
            return w.audioOffset + w.audioDuration < currentPlayTime;
        });
        return lastIndex === -1 ? words.pop() : words[lastIndex - 1];
    }, [currentPlayTime, passageDetails]);
    const submitFeedback = (0, react_1.useCallback)(() => {
        var _a;
        const feedbackText = (_a = textInputRef.current) === null || _a === void 0 ? void 0 : _a.value;
        executeSendFeedback(passageDetails.meta.id, feedbackText, {
            foreAudioOffset: (currentWord === null || currentWord === void 0 ? void 0 : currentWord.audioOffset) != null
                ? Math.floor(currentWord.audioOffset)
                : undefined,
            realAudioOffset: currentPlayTime != null ? Math.floor(currentPlayTime) : undefined,
        });
    }, [
        currentPlayTime,
        currentWord === null || currentWord === void 0 ? void 0 : currentWord.audioOffset,
        executeSendFeedback,
        passageDetails.meta.id,
    ]);
    (0, react_1.useEffect)(() => {
        if (sendFeedbackStatus === use_lazy_promise_1.FetchStatus.Success) {
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        }
    }, [sendFeedbackStatus, onSubmit]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", padding: 2, spacing: 2, width: "100%", children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "h6", fontWeight: "bold", children: ["Passage Title: ", passageDetails.meta.title] }), currentWord ? ((0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "body1", children: ["Current Word: ", currentWord.units.map((u) => u.text).join("")] })) : null, (0, jsx_runtime_1.jsx)(material_1.TextField, { inputRef: textInputRef, multiline: true, rows: 4, variant: "outlined", placeholder: "Enter your feedback here..." }), sendFeedbackStatus === use_lazy_promise_1.FetchStatus.Error ? ((0, jsx_runtime_1.jsx)(material_1.Typography, { color: "error", variant: "body2", children: "Failed to submit feedback. Please try again." })) : null, (0, jsx_runtime_1.jsx)(button_1.Button, { variant: "contained", color: "primary", eventName: log_1.LogEventClickName.SendFeedback, onClick: submitFeedback, disabled: sendFeedbackStatus === use_lazy_promise_1.FetchStatus.Loading, startIcon: sendFeedbackStatus === use_lazy_promise_1.FetchStatus.Loading ? ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { size: 20 })) : null, sx: { alignSelf: "flex-end" }, children: "Submit Feedback" })] }));
});
exports.FeedbackContainer.displayName = "FeedbackContainer";
